module.exports = {
  context: {
    name: 'Intro',
    overline: 'limitless pathways',
    heading: 'Belonging is what happens when our approach to care meets the real needs of the people we serve'
  }
}
